import type { ConversationDetail } from '@/features/conversations/api';
import { getLeadFormResponse } from '@/features/customers/components/lead-form-response';
import { useLead } from '@/features/leads/api/get-lead/get-lead.hook';
import { conversationLeadId } from './conversation-thread-events';

/** Share the form card's cached lead, including names saved after the call began. */
export function useConversationIdentity(conversation: ConversationDetail) {
  const { lead } = useLead({ leadId: conversationLeadId(conversation) ?? '' });
  const name = lead
    ? [lead.firstName === 'Unknown' ? null : lead.firstName, lead.lastName]
        .filter(Boolean)
        .join(' ')
        .trim()
    : '';
  return {
    displayName:
      name || conversation.externalUserName || conversation.externalUserId,
    formName: lead ? getLeadFormResponse(lead)?.formName : null,
  };
}
